module.exports = "\n  <div class=\"modal-body\">\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <video controls class=\"video\">\n      <source src=\"../../assets/video/Voyager_Movie.m4v\" type=\"video/mp4\">\n      </video>\n    </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/video-modal/video-modal.component.html
// module id = ./src/app/video-modal/video-modal.component.html
// module chunks = main